import { useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { EligibleFuelCard } from 'components/direct-sales/select-options/components/EligibleFuelCard';
import { MixedMeterCard } from './MixedMeterCard';
import { ChangeTariffCard } from 'components/direct-sales/select-options/components/ChangeTariffCardRevamp';
import { UnmeteredCard } from 'components/direct-sales/select-options/components/UnmeteredCard';
import { HomeMoveCard } from 'components/direct-sales/select-options/components/HomeMoveCard';
import { BgLiteCard } from 'components/direct-sales/select-options/components/BgLiteCard';
import { useMeterExceptions } from 'components/direct-sales/select-options/hooks/useMeterExceptions';
import { DeEnergisedCard } from './DeEnergisedCard';
import { RelatedMeterCard } from 'components/direct-sales/select-options/components/RelatedMeterCard';
import { selectHistory } from 'state/journey-routes/journey-routes-slice';
import { checkMatchPath } from 'utils/misc';
import { routePath } from 'config/route-config';
import { setInitialState as resetFuelType } from 'state/fuel-type/fuel-type-slice';
import { pushEvent } from 'state/analytics/analytics-slice';
import { CardsContext } from 'components/direct-sales/select-options/contexts/CardContext';
import { FUEL_OPTIONS } from 'config/app-config';

export const testId = 'selectOptionsTestId';

export const SelectOptionsContent = () => {
  const dispatch = useDispatch();
  const cardsRef = useRef<string[]>([]);
  const { errors, hasMeterExceptions } = useMeterExceptions();

  const historyStack = useSelector(selectHistory, shallowEqual);
  const hasVisitedFuelTypePage = !!historyStack.find((path) =>
    checkMatchPath(path, routePath.energyNeeds)
  );

  const registerCard = (card) =>
    (cardsRef.current = Array.from(new Set([...cardsRef.current, card])));

  useEffect(() => {
    // back navigation reset fuel type in case it was not set by fuelType page (meter validation)
    // to show same errors when returning to select options page
    !hasVisitedFuelTypePage && dispatch(resetFuelType());

    hasMeterExceptions &&
      dispatch(
        pushEvent({
          category: 'error',
          status: errors
            .reduce((acc, error) => {
              return [...acc, `${error?.code}:${error?.keyword}`];
            }, [])
            .join(';')
        })
      );

    dispatch(
      pushEvent({
        category: 'nep_aquisition',
        action: 'impression',
        label: cardsRef.current.join(';')
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid={testId}>
      <NsColumn hockeypitch="3">
        <CardsContext.Provider value={{ registerCard }}>
          <ChangeTariffCard errors={errors} name="changeTariff" />
          <HomeMoveCard errors={errors} name="homeMove" />
          <EligibleFuelCard name="eligibleFuel" />
          <UnmeteredCard errors={errors} name="unmetered" />
          <BgLiteCard errors={errors} name="bgLite" />
          <DeEnergisedCard errors={errors} name="deEnergised" />
          <RelatedMeterCard errors={errors} name="relatedMeter" />
          <MixedMeterCard
            name="mixedMeterElectricity"
            decoration="bulb"
            fuelType={FUEL_OPTIONS.ELECTRIC}
          />
          <MixedMeterCard
            name="mixedMeterGas"
            decoration="gas"
            fuelType={FUEL_OPTIONS.GAS}
          />
        </CardsContext.Provider>
      </NsColumn>
    </div>
  );
};

export default SelectOptionsContent;
